import { Flex, Grid, Text } from '@chakra-ui/react';
import { useCallback } from 'react';
import { CategoryTag as Vertical } from '~/components/CategoryTag/CategoryTag.model';
import { verticalOptions } from '~/screens/MyAgency/components/Table/Verticals';
import { SelectButton } from '~/screens/MyAgency/components/utils';
import { useCreatorsFiltersStore } from '~/screens/MyAgency/store';

import { talentFiltersTrackId } from './constants';

export const VerticalFilters: React.FC = () => {
  const { verticals, setVerticals, clearAllFilters, appliedFilters } =
    useCreatorsFiltersStore();

  const onSelectVerticals = useCallback(
    (name: Vertical) => {
      const isSelected = verticals.includes(name);

      let newVerticals = [...verticals];

      if (isSelected) {
        newVerticals = verticals.filter(
          (vertical: string) => vertical !== name,
        );
      } else {
        newVerticals = [...verticals, name];
      }
      setVerticals(newVerticals as Vertical[]);

      if (appliedFilters.length === 1 && isSelected) {
        clearAllFilters();
      }
    },
    [verticals, setVerticals, clearAllFilters, appliedFilters],
  );

  return (
    <Flex flexDirection="column" gap={2}>
      <Text fontSize="lg" fontWeight="500" color="primary.500">
        Verticals
      </Text>
      <Grid
        templateColumns="repeat(3, 1fr)"
        gap={2}
        track-id={talentFiltersTrackId.verticalList}
      >
        {Object.values(verticalOptions).map(
          (v: { name: Vertical; color: string }) => {
            const isSelected = verticals.includes(v.name);
            const isDisabled = !isSelected && verticals.length === 3;

            return (
              <SelectButton
                key={v.name}
                value={v.name}
                isSelected={isSelected}
                isDisabled={isDisabled}
                onSelect={onSelectVerticals}
              />
            );
          },
        )}
      </Grid>
    </Flex>
  );
};
